import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { Frame } from "@bitesite/react-figstrap";
import { Text } from "../../odc-ui";

import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Bar } from "react-chartjs-2";

Chart.register(CategoryScale);

const ChartContainer = styled.div`
  height: 225px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

/* data is expected to come in with x-axis values as keys, and y-axis values as values */
const RewardCalculatorGraph = ({ title, data, animated }) => {
  const dataIsEmpty = () => {
    return Object.keys(data).length === 0;
  };

  const chartData = useMemo(() => {
    return {
      labels: data.map((row) => row.month),
      datasets: [
        {
          data: data.map((row) => row.balance),
        },
      ],
    };
  });

  const options = {
    animation: animated,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (context) => {
            let title = "Month";

            if (context[0] && context[0].parsed.x !== null) {
              title += " " + (parseInt(context[0].parsed.x) + 1);
            }

            return title;
          },
          label: (context) => {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }

            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: (value) => {
            return "$" + value;
          },
        },
        title: { display: true, text: "CAD" },
      },
      x: {
        title: { display: true, text: "MONTH" },
      },
    },
  };

  if (dataIsEmpty()) {
    return null;
  }

  return (
    <Frame vertical gap={10}>
      <Text>{title}</Text>
      <ChartContainer>
        <Bar data={chartData} options={options} />
      </ChartContainer>
    </Frame>
  );
};

RewardCalculatorGraph.defaultProps = {
  animated: true,
};

RewardCalculatorGraph.propTypes = {
  title: PropTypes.string,
  animated: PropTypes.bool,
  data: PropTypes.array.isRequired,
};

export default RewardCalculatorGraph;
